export const PREV_INPUT_TAG = '_input';
export const SEARCH_HISTORY_TAG = '_historyDisplayKey';



/** WEBPACK FOOTER **
 ** ./src/components/partials/AlgoliaPlaces/constants.js
 **/